import React from "react";
import "../../scss/newEditor/newEditos.scss";
import { NavLink } from "react-router-dom";
import { Link } from "react-scroll";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircle, faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";
function SectionChild({ text, activeStep, id, handleClick, item }) {
  const { t } = useTranslation(["newEditor", "common"]);

  return (
    <div
      onClick={() => handleClick(item)}
      key={id}
      id={id}
      className={
        activeStep === id && activeStep != undefined && id != undefined
          ? "newEditor__sectionChild sectionChild--active"
          : "newEditor__sectionChild"
      }
    >
      {item?.isModified === true ? (
        <FontAwesomeIcon
          icon={faCheckCircle}
          className="CheckCircle"
          color="#f37b33"
        />
      ) : (
        <div className="circle"></div>
      )}
      <p id={id}>
        {text?.length > 0
          ? text
          : t(`sections.${item.type}`) !== `sections.${item.type}`
          ? t(`sections.${item.type}`)
          : item.type}
      </p>
    </div>
  );
}

export default SectionChild;
